import { cn } from '@/lib/utils';

/** Title + optional subtitle shown above each auth form. */
export function FormHeader({
  title,
  subtitle,
  className,
}: {
  title: string;
  subtitle?: string;
  className?: string;
}) {
  return (
    <div className={cn('mb-7 space-y-1.5', className)}>
      <h1 className="font-display text-[1.7rem] font-bold leading-tight tracking-tight text-foreground text-balance">
        {title}
      </h1>
      {subtitle ? (
        <p className="text-sm text-muted-foreground text-pretty">{subtitle}</p>
      ) : null}
    </div>
  );
}
